var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-card',{staticClass:"mt-20 mb-20 mr-20 card-base",staticStyle:{"border":"none","color":"white"}},[_vm._v("\n\tDAM Corp. "),_c('small',[_vm._v("(v"+_vm._s(_vm.pjson.version)+")")])])
}
var staticRenderFns = []

export { render, staticRenderFns }